/**
 * @generated SignedSource<<2aaa76634365e6efe44a1124ada02463>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkPaymentTerm_charge$data = {
  readonly company: {
    readonly id: string;
    readonly preferences: {
      readonly chargeSettings: {
        readonly expiration: {
          readonly fakeValue: number | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly expiresDate: string | null | undefined;
  readonly interestsSettings: {
    readonly daysAfterDueDate: number | null | undefined;
  } | null | undefined;
  readonly status: string | null | undefined;
  readonly " $fragmentType": "PaymentLinkPaymentTerm_charge";
};
export type PaymentLinkPaymentTerm_charge$key = {
  readonly " $data"?: PaymentLinkPaymentTerm_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkPaymentTerm_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkPaymentTerm_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiresDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyPreferences",
          "kind": "LinkedField",
          "name": "preferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyPreferencesCharge",
              "kind": "LinkedField",
              "name": "chargeSettings",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ChargeExpiration",
                  "kind": "LinkedField",
                  "name": "expiration",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "type",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fakeValue",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChargeSettingsInterests",
      "kind": "LinkedField",
      "name": "interestsSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "daysAfterDueDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "0e11984741427233fa49668ea50792cd";

export default node;
